import * as httpClient from '../clients/httpClient'
import { chunkArray } from '../utilities/arrayUtility'
import { splitAndSettlePromises } from '../utilities/asyncUtility'

const getJurisdictions = async (uniqueNames, publishStatus = 'published') => {
  const queryParameters = { uniqueNames, publishStatus }
  const result = await httpClient.getJsonResponse({ path: '/admin/api/jurisdictions', method: 'GET', queryParameters })

  if (result.statusCode !== 200) throw new Error('error getting jurisdictions')
  return result.body.data
}

const getJdUniqueNameToDocDict = async (uniqueNames, publishStatus = 'published') => {
  const requests = chunkArray(uniqueNames, 50)
  const jurisdictionDocsResults = await splitAndSettlePromises(requests.map((request) => getJurisdictions(request, publishStatus)))

  if (jurisdictionDocsResults.rejected.length > 0) console.error('Error getting jurisdiction details')

  const jurisdictionDocs = jurisdictionDocsResults.resolved.flat()

  return jurisdictionDocs.reduce((_dict, jdDoc) => {
    _dict[jdDoc.uniqueName] = jdDoc

    return _dict
  }, {})
}

module.exports = {
  getJurisdictions,
  getJdUniqueNameToDocDict
}
